import Axios from 'axios';

//const api = "http://192.168.0.7:8080/facilitapay/";
const api = "https://checkout.cliqx.com.br/pay/"


export default {

    validaLink(uuid){
        const headers   = { "Content-Type": "application/json" };
        const service = api + 'p/order/' + uuid;
        
        return Axios.get(service, {headers});
    },

    enviaCheckout(body){

        var config = {
            method: 'post',
            url: api + 'p/send/checkout',
            headers: { 'Content-Type': 'application/json' },
            data : body
          };

        //console.log(body);
        //const headers   = { "Content-Type": "application/json" };
        //const service = api + 'p/send/checkout';
        
        return Axios(config);
    },

}

